var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Message.SelectCopyContent"),
        width: "400px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            { attrs: { "label-position": "left" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "1" },
                      model: {
                        value: _vm.listType,
                        callback: function($$v) {
                          _vm.listType = $$v
                        },
                        expression: "listType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(
                          _vm._s(_vm.$t("SystemMaintenance.BookingSuccessful"))
                        )
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.ToBeConfirmed")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "285px" },
                    attrs: { no: "2", type: "textarea", rows: 10 },
                    model: {
                      value: _vm.note,
                      callback: function($$v) {
                        _vm.note = $$v
                      },
                      expression: "note"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "3" },
                      model: {
                        value: _vm.fillType,
                        callback: function($$v) {
                          _vm.fillType = $$v
                        },
                        expression: "fillType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FillSO")))
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FillMBL")))
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FillALL")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-left": "24px",
                "font-size": "12px",
                "-webkit-font-smoothing": "antialiased",
                "text-rendering": "optimizeLegibility",
                "font-family":
                  "Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif"
              }
            },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("Message.CopyNumber")))]),
              _c("el-input-number", {
                staticStyle: { width: "100px" },
                attrs: {
                  no: "CopyNumber",
                  value: _vm.copyNum,
                  precision: 0,
                  min: 1,
                  max: 100,
                  "controls-position": "right"
                },
                on: { input: _vm.numFunction }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }